.submitButton {
  margin-left: 1em;
  border-radius: 0;
}

.recipientList {
  padding-bottom: 10px;
}

.expandButton {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue);

  &:hover {
    color: var(--darkBlue);
  }
}
